import Vue from 'vue';
import Vuetify from 'vuetify';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';
import nl from 'vuetify/src/locale/nl';
import '@mdi/font/css/materialdesignicons.css';

const vuetify = new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#107fb0',
        background: '#f5f5f5'
      },
      dark: {
        primary: '#0C658C',
        background: '#1e1e1e'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { nl },
    current: 'nl'
  }
});

Vue.use(Vuetify);

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'md',
  lang: {
    locales: { nl },
    current: 'nl'
  }
});

export default vuetify;
